export default {
  namespaced: true,
  state: {
    showCoreNav: false,
  },
  getters: {
    showCoreNav: (state) => state.showCoreNav,
  },
  mutations: {
    toggleCoreNav(state) {
      state.showCoreNav = !state.showCoreNav;
    },
  },
  actions: {
    toggleCoreNav({ commit, dispatch }) {
      dispatch('env/loadEnvironment', 'test', { root: true });
      commit('toggleCoreNav');
    },
  },
};
